module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/cm-gallery/cm-gallery-04-86452df80487fa5de183c259d140467d.jpg";